import {detect as detectBrowser} from 'detect-browser';

var $ = jQuery;

// IE object-fit fallback
function ie_objectfit_fallback () {
    if(detectBrowser().name != 'ie')
        return;

    $('.article-teaser__image:not(.ie-object-fit)').each(function () {
        ie_objectfit_fallback_container($(this));
    });
}

function ie_objectfit_fallback_container ($container) {
    if(detectBrowser().name != 'ie')
        return;

    $container = $($container);

    var imgUrl = $container.find('img').prop('src');
    if (imgUrl) {
        $container
            .css('backgroundImage', 'url(' + imgUrl + ')')
            .addClass('ie-object-fit');
    }
}

export {
    ie_objectfit_fallback,
    ie_objectfit_fallback_container,
}



// WEBPACK FOOTER //
// ./js/regular/fallbacks.js